/**
 * Stable empty-array / empty-object constants for Zustand selectors.
 *
 * Bug pattern this prevents (caused the 2026-04-26 React #185 prod crash):
 *
 *   useStateStore((s) => s.positions.snapshot?.open ?? [])
 *
 * When `snapshot` is null (between mount and bootstrap completing), the
 * selector returns a brand-new `[]` on every call. Zustand's default
 * Object.is equality check sees `[] !== []` → triggers re-render → the
 * selector runs again → new `[]` → re-render → max-update-depth crash.
 *
 * Fix:
 *
 *   useStateStore((s) => s.positions.snapshot?.open ?? EMPTY_ARRAY)
 *
 * Same frozen reference every call → Object.is equal → no spurious re-render.
 *
 * Cast at the call site to the row type — readonly is intentional so a
 * caller can't accidentally mutate the shared instance.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const EMPTY_ARRAY: readonly any[] = Object.freeze([]);
export const EMPTY_OBJECT: Readonly<Record<string, never>> = Object.freeze({});
